import TooltipWrapper from './tooltip-wrapper';

export default TooltipWrapper;
